import MuiTextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

const TextField = styled(MuiTextField)`
  & .MuiInputLabel-root.Mui-focused {
    color: #f05623;
  };
  & .MuiInput-underline:after {
    border-bottom-color: #f05623;
  };
`;

export default TextField;
